<template>
  <div class="tmpWrap">
    <button @click="printReady"> print </button>
    <Loading :visible="loading"/>
  </div>
</template>

<script>
import pdfMake from 'pdfmake/build/pdfmake';
// import pdfFonts from 'pdfmake/build/vfs_fonts'; // 빌드버전 사용가능 
import pdfFonts from '@components/pdf/pdfmake/vfs_fonts'; // 커스텀 버전 사용가능 
import CommNew, {typeOfJson} from "@processEditor/CommNew";
import Loading from '@common/loading.vue'
import MakeNodesInfomation from '@components/platform_new/wikiApi.js'

const makeNodes = new MakeNodesInfomation();

pdfMake.vfs = pdfFonts.pdfMake.vfs;
pdfMake.tableLayouts = {
  depth1Layout: {
    hLineWidth: function (i) {
      return 0.5
    },
    vLineWidth: function (i) {
      return 0.5
    },
    hLineColor: function (i) {
      return '#dddddd';
    },
    vLineColor: function (i) {
      return '#dddddd';
    },
    paddingLeft:function () { return 3 },
    paddingTop:function () { return 3 },
    paddingRight:function () { return 3 },
    paddingBottom:function () { return 3 },
    
  },
  depth2Layout: {
    hLineWidth: function (i) {
      return 0.5
    },
    vLineWidth: function (i) {
      return 0.5
    },
    hLineColor: function (i) { return '#dddddd'; },
    vLineColor: function (i) { return '#dddddd'; },
    paddingLeft:function () { return 3 },
    paddingTop:function () { return 3 },
    paddingRight:function () { return 3 },
    paddingBottom:function () { return 3 },
  }
};

export default {
  name : 'pdf-wiki' , 
  mixins : [ CommNew ] , 
  components : {
    Loading , 
  } , 
  data () {
    return {
      loading : false , 
      crntProtocol : null , 
      nodeMemoInfo : {} , 
      nodeContentInfo : {} , 
      nodeMap : new Map() , 
      editorList : null , 
      images: null,
      headImages: null,
      titleImages: null
    }
  } , 
  async mounted () {
  } , 
  methods : {
    /**
     * PDF로 작성될 Protocol 을 가져옵니다. 
     */
    async getProtocol(processId){
      const TAKey = this.$route.query.TAKey; 
      const isPublish = this.$route.query.isPublish;    
      let param = { 
        processId , 
        isMemo : false , 
        isConent : true , 
        isComment  : false , 
        taKey : TAKey,
        isPublish : isPublish ?? '',
      };
      let rslt;
      if( !TAKey ){
        rslt = await this.$wApi.protocol.getProtocols(param);
      }else{
        param.taKey = param.taKey.replaceAll(' ', '+');
        rslt = await this.$wApi.protocol.takey(param);
      }
      
      rslt.map(( info ) => {
        info.json = JSON.parse( info.json ) ; 
        if ( info.nodeMemo ) info.nodeMemo = JSON.parse( info.nodeMemo ) ; 
        if ( info.nodeContent ) info.nodeContent = JSON.parse( info.nodeContent ) ; 
      }) ; 
      return rslt ; 
    },

    async setProtocolInfo ({ processId , protocolId , keyOfProtocol }) {
      const protocols = await this.getProtocol( processId ) ; 
      const slctProtocol = protocols.filter( protocol => protocol.id == protocolId )[0] ; 
      this.crntProtocol = slctProtocol ; 
      this.crntProtocol.processId = processId;
    } , 

    /**
     * 작성자 정보를 가져옵니다. 
     */
    async setWriter () {
      const { crntProtocol } = this ; 
      if( crntProtocol ) {
        const response = await this.$wApi.protocol.optionUser.get( null, crntProtocol.id ) ; 
        this.updatePdfWiki({ writer : response.user }) ; // pdf 저장용( 작성자 ) 
      }
    } , 

    loadImage (src){
      return new Promise((resolve) => {
        const img = new Image();
        img.src = src;
        img.onload = () => resolve( img );
        img.onerror = () => resolve(null);
      });
    },

    async checkImageSize(src) {
      const img = await this.loadImage(src);
      const { naturalWidth , naturalHeight } = img ; 
      const A4Width = 595.28 ; 
      const A4Height = 841.89 ; 
      const remainedSize = 80 ; 

      let width = naturalWidth;
      let height = naturalHeight;

      if (width > A4Width ) {
        const ratio = (A4Width - remainedSize) / naturalWidth
        width *= ratio;
        height *= ratio;
      }
      
      return { image: img.src , width, height }
    },

    async printHandler (openType='open') {
      const crntProtocol = this.crntProtocol;
      const typeNumber = `${crntProtocol.fieldName ? crntProtocol.fieldName.split('>')[0]:''}-${crntProtocol.processId}-${crntProtocol.id}`;
      pdfMake.fonts = {
        NanumSquare: {
          normal: 'NanumSquareR.ttf',
          bold: 'NanumSquareB.ttf',
          // italics: 'NanumSquareR.ttf',
          // bolditalics: 'NanumSquareEB.ttf',
        } , 
        NanumSquareB: {
          normal: 'NanumSquareB.ttf',
          bold: 'NanumSquareB.ttf',
        } , 
        NanumSquareEB: {
          normal: 'NanumSquareEB.ttf',
          bold: 'NanumSquareEB.ttf',
        } , 
        SourceSerifPro: {
          normal: 'SourceSerifPro-Bold.ttf',
          bold: 'SourceSerifPro-Bold.ttf',
          italics: 'SourceSerifPro-Bold.ttf',
          bolditalics: 'SourceSerifPro-Bold.ttf',
        } , 
      } ;
      let titleArr = []
      let headArr = []
        const titleImg = await this.loadImage(this.titleImages);
        let titleWidth = titleImg.naturalWidth;
        let titleHeight = titleImg.naturalHeight;
        titleWidth *= 580 / titleImg.naturalWidth
        titleHeight *= 580 / titleImg.naturalWidth
        titleArr.push(await this.checkImageSize(this.titleImages));
        titleArr[0] = {...titleArr[0], absolutePosition: { x: 70 , y: 270 }}
        const headImg = await this.loadImage(this.headImages);
        let headWidth = headImg.naturalWidth;
        let headHeight = headImg.naturalHeight;
        headWidth *= 700 / headImg.naturalWidth
        headHeight *= 700 / headImg.naturalWidth
        headArr.push(await this.checkImageSize(this.headImages))
      headArr[0] = {...headArr[0], marginTop: 6}

      let textArr = [];
      for(const image of this.images) {
        textArr.push(await this.checkImageSize(image));
      }

      function formatDateString(dateString) {
        if( !dateString ) return "-";

        var date = new Date(dateString);
        var year = date.getFullYear();
        var month = ("0" + (date.getMonth() + 1)).slice(-2);
        var day = ("0" + date.getDate()).slice(-2);

        return year + "-" + month + "-" + day;
      }

      function header (currentPage, pageCount , pageSize) {
        if (currentPage === 1) {
          return null; // 첫 번째 페이지에서는 헤더를 표시하지 않음
        }
        // if (currentPage === pageCount) {
        //   return { /* 마지막 페이지에서 다른 디자인의 헤더 표시 */ };
        // }
        // 나머지 페이지에서는 기본 헤더 표시

        return {
          margin: [40, 10, 40, 0], // 상단 여백 지정
          stack: [
            {
              columns: [
                {
                  svg: `
                    <svg fill="none">
                      <path d="M11.424 6.176V5.744H13.28V6.176L12.52 6.272L11.464 7.536L13.04 10.512L13.528 10.568V11H11.216V10.568L11.6 10.528L10.616 8.536L10.16 9.08C10.16 9.30933 10.16 9.544 10.16 9.784C10.1653 10.024 10.1707 10.264 10.176 10.504L10.696 10.568V11H8.264V10.568L8.864 10.504C8.87467 10.1787 8.88 9.85067 8.88 9.52C8.88 9.18933 8.88 8.856 8.88 8.52V8.224C8.88 7.89333 8.88 7.56267 8.88 7.232C8.88 6.896 8.87467 6.56533 8.864 6.24L8.264 6.176V5.744H10.784V6.176L10.176 6.24C10.1707 6.56533 10.1653 6.89333 10.16 7.224C10.16 7.55467 10.16 7.888 10.16 8.224V8.488L11.952 6.272L11.424 6.176ZM13.6481 9.328V8.608H15.7201V9.328H13.6481ZM16.1049 11V10.568L16.8809 10.472V6.256L16.1769 6.176V5.744H18.2889L19.5929 9.264L20.8169 5.744H22.8409V6.176L22.2729 6.24C22.2676 6.56533 22.2623 6.896 22.2569 7.232C22.2569 7.56267 22.2569 7.89333 22.2569 8.224V8.52C22.2569 8.85067 22.2569 9.18133 22.2569 9.512C22.2623 9.84267 22.2676 10.1733 22.2729 10.504L22.8649 10.568V11H20.3129V10.568L20.8969 10.496C20.9076 10.1707 20.9103 9.85333 20.9049 9.544C20.9049 9.23467 20.9076 8.94933 20.9129 8.688L20.9289 6.92L19.5049 11H18.8889L17.3609 6.912L17.4009 8.512V10.464L18.0569 10.568V11H16.1049ZM26.2966 11.112C25.8326 11.112 25.5392 10.92 25.4166 10.536C25.2459 10.7173 25.0806 10.8613 24.9206 10.968C24.7659 11.0693 24.5499 11.12 24.2726 11.12C23.9632 11.12 23.7099 11.032 23.5126 10.856C23.3206 10.68 23.2246 10.4267 23.2246 10.096C23.2246 9.904 23.2672 9.73067 23.3526 9.576C23.4379 9.42133 23.5926 9.27733 23.8166 9.144C24.0406 9.01067 24.3579 8.88533 24.7686 8.768C24.8486 8.74133 24.9419 8.71467 25.0486 8.688C25.1552 8.66133 25.2646 8.63467 25.3766 8.608V8.344C25.3766 7.98667 25.3312 7.744 25.2406 7.616C25.1552 7.488 24.9846 7.424 24.7286 7.424C24.6912 7.424 24.6566 7.424 24.6246 7.424C24.5926 7.424 24.5552 7.42667 24.5126 7.432L24.4726 7.784C24.4672 8.04533 24.4059 8.23467 24.2886 8.352C24.1766 8.46933 24.0432 8.528 23.8886 8.528C23.5952 8.528 23.4166 8.39467 23.3526 8.128C23.3739 7.79733 23.5419 7.528 23.8566 7.32C24.1712 7.112 24.6166 7.008 25.1926 7.008C25.7046 7.008 26.0699 7.12533 26.2886 7.36C26.5126 7.59467 26.6246 7.98133 26.6246 8.52V10.312C26.6246 10.4667 26.6832 10.544 26.8006 10.544C26.8432 10.544 26.8832 10.5333 26.9206 10.512C26.9579 10.4853 26.9979 10.4373 27.0406 10.368L27.2566 10.512C27.1606 10.7253 27.0352 10.88 26.8806 10.976C26.7312 11.0667 26.5366 11.112 26.2966 11.112ZM24.4086 9.888C24.4086 10.0853 24.4539 10.232 24.5446 10.328C24.6406 10.424 24.7552 10.472 24.8886 10.472C24.9472 10.472 25.0086 10.4587 25.0726 10.432C25.1366 10.4053 25.2379 10.344 25.3766 10.248V8.952C25.3072 8.97333 25.2379 8.99733 25.1686 9.024C25.1046 9.04533 25.0486 9.06667 25.0006 9.088C24.8192 9.16267 24.6752 9.26933 24.5686 9.408C24.4619 9.54133 24.4086 9.70133 24.4086 9.888ZM27.3023 12.816V12.44L27.7503 12.344C27.7556 12.0933 27.7583 11.8587 27.7583 11.64C27.7636 11.4267 27.7663 11.2213 27.7663 11.024V8.856C27.7663 8.63733 27.7636 8.46933 27.7583 8.352C27.7583 8.22933 27.753 8.088 27.7423 7.928L27.2463 7.856V7.544L28.8143 7.008L28.9503 7.088L28.9823 7.536C29.3183 7.184 29.713 7.008 30.1663 7.008C30.4596 7.008 30.7236 7.08533 30.9583 7.24C31.193 7.39467 31.3796 7.624 31.5183 7.928C31.6623 8.232 31.7343 8.60533 31.7343 9.048C31.7343 9.47467 31.6543 9.84533 31.4943 10.16C31.3343 10.4693 31.1236 10.7067 30.8623 10.872C30.6063 11.0373 30.3263 11.12 30.0223 11.12C29.6116 11.12 29.2756 10.9813 29.0143 10.704V11.016C29.0143 11.2133 29.0143 11.4187 29.0143 11.632C29.0196 11.8453 29.025 12.0747 29.0303 12.32L29.5423 12.44V12.816H27.3023ZM29.5823 7.704C29.481 7.704 29.385 7.72533 29.2943 7.768C29.209 7.81067 29.1236 7.864 29.0383 7.928V10.248C29.1983 10.3813 29.3716 10.448 29.5583 10.448C29.7983 10.448 29.993 10.336 30.1423 10.112C30.297 9.888 30.3743 9.53867 30.3743 9.064C30.3743 8.58933 30.2996 8.24533 30.1503 8.032C30.0063 7.81333 29.817 7.704 29.5823 7.704ZM36.0959 6.208H35.9119C35.9065 6.53867 35.9012 6.872 35.8959 7.208C35.8959 7.544 35.8959 7.88267 35.8959 8.224V8.544H36.1279C36.4799 8.544 36.7439 8.432 36.9199 8.208C37.0959 7.97867 37.1839 7.68267 37.1839 7.32C37.1839 6.952 37.0879 6.67467 36.8959 6.488C36.7092 6.30133 36.4425 6.208 36.0959 6.208ZM33.9359 6.176V5.744H36.1119C36.6665 5.744 37.1145 5.81067 37.4559 5.944C37.7972 6.072 38.0452 6.256 38.1999 6.496C38.3599 6.73067 38.4399 7.008 38.4399 7.328C38.4399 7.632 38.3652 7.912 38.2159 8.168C38.0719 8.41867 37.8319 8.61867 37.4959 8.768C37.1599 8.91733 36.7012 8.992 36.1199 8.992H35.8959C35.8959 9.22133 35.8959 9.464 35.8959 9.72C35.9012 9.97067 35.9065 10.2293 35.9119 10.496L36.6239 10.568V11H33.9359V10.568L34.5359 10.504C34.5465 10.1787 34.5519 9.85067 34.5519 9.52C34.5519 9.18933 34.5519 8.856 34.5519 8.52V8.224C34.5519 7.89333 34.5519 7.56267 34.5519 7.232C34.5519 6.896 34.5465 6.56533 34.5359 6.24L33.9359 6.176ZM38.6768 11V10.624L39.1168 10.528C39.1221 10.3253 39.1248 10.1227 39.1248 9.92C39.1301 9.71733 39.1328 9.51733 39.1328 9.32V5.968L38.6368 5.888V5.552L40.3168 5.192L40.4448 5.272L40.4128 6.392V9.32C40.4128 9.52267 40.4128 9.72533 40.4128 9.928C40.4181 10.1307 40.4234 10.3333 40.4288 10.536L40.8688 10.624V11H38.6768ZM44.2966 11.112C43.8326 11.112 43.5392 10.92 43.4166 10.536C43.2459 10.7173 43.0806 10.8613 42.9206 10.968C42.7659 11.0693 42.5499 11.12 42.2726 11.12C41.9632 11.12 41.7099 11.032 41.5126 10.856C41.3206 10.68 41.2246 10.4267 41.2246 10.096C41.2246 9.904 41.2672 9.73067 41.3526 9.576C41.4379 9.42133 41.5926 9.27733 41.8166 9.144C42.0406 9.01067 42.3579 8.88533 42.7686 8.768C42.8486 8.74133 42.9419 8.71467 43.0486 8.688C43.1552 8.66133 43.2646 8.63467 43.3766 8.608V8.344C43.3766 7.98667 43.3312 7.744 43.2406 7.616C43.1552 7.488 42.9846 7.424 42.7286 7.424C42.6912 7.424 42.6566 7.424 42.6246 7.424C42.5926 7.424 42.5552 7.42667 42.5126 7.432L42.4726 7.784C42.4672 8.04533 42.4059 8.23467 42.2886 8.352C42.1766 8.46933 42.0432 8.528 41.8886 8.528C41.5952 8.528 41.4166 8.39467 41.3526 8.128C41.3739 7.79733 41.5419 7.528 41.8566 7.32C42.1712 7.112 42.6166 7.008 43.1926 7.008C43.7046 7.008 44.0699 7.12533 44.2886 7.36C44.5126 7.59467 44.6246 7.98133 44.6246 8.52V10.312C44.6246 10.4667 44.6832 10.544 44.8006 10.544C44.8432 10.544 44.8832 10.5333 44.9206 10.512C44.9579 10.4853 44.9979 10.4373 45.0406 10.368L45.2566 10.512C45.1606 10.7253 45.0352 10.88 44.8806 10.976C44.7312 11.0667 44.5366 11.112 44.2966 11.112ZM42.4086 9.888C42.4086 10.0853 42.4539 10.232 42.5446 10.328C42.6406 10.424 42.7552 10.472 42.8886 10.472C42.9472 10.472 43.0086 10.4587 43.0726 10.432C43.1366 10.4053 43.2379 10.344 43.3766 10.248V8.952C43.3072 8.97333 43.2379 8.99733 43.1686 9.024C43.1046 9.04533 43.0486 9.06667 43.0006 9.088C42.8192 9.16267 42.6752 9.26933 42.5686 9.408C42.4619 9.54133 42.4086 9.70133 42.4086 9.888ZM46.9706 11.12C46.6132 11.12 46.3332 11.0347 46.1306 10.864C45.9279 10.688 45.8266 10.4027 45.8266 10.008C45.8266 9.86933 45.8266 9.74133 45.8266 9.624C45.8319 9.50133 45.8346 9.36267 45.8346 9.208V7.68H45.3146V7.208L45.9066 7.128L46.3066 6.008H47.1226L47.1066 7.136H47.9466V7.68H47.1066V9.92C47.1066 10.1067 47.1439 10.2453 47.2186 10.336C47.2986 10.4213 47.3972 10.464 47.5146 10.464C47.6532 10.464 47.7972 10.4053 47.9466 10.288L48.1466 10.48C48.0399 10.6827 47.8906 10.84 47.6986 10.952C47.5119 11.064 47.2692 11.12 46.9706 11.12ZM48.3338 11V10.624L48.7738 10.536C48.7791 10.3333 48.7818 10.1307 48.7818 9.928C48.7871 9.72533 48.7898 9.52267 48.7898 9.32V7.68H48.2698V7.208L48.8058 7.144C48.8484 6.78133 48.9178 6.49067 49.0138 6.272C49.1151 6.048 49.2511 5.848 49.4218 5.672C49.6191 5.47467 49.8404 5.33333 50.0858 5.248C50.3364 5.15733 50.5764 5.112 50.8058 5.112C51.0298 5.112 51.2324 5.15467 51.4138 5.24C51.5951 5.32 51.7124 5.46667 51.7658 5.68C51.7604 5.82933 51.7071 5.95733 51.6058 6.064C51.5098 6.16533 51.3711 6.216 51.1898 6.216C51.0564 6.216 50.9311 6.17067 50.8138 6.08C50.6964 5.98933 50.5818 5.84533 50.4698 5.648L50.4058 5.552C50.2618 5.70133 50.1631 5.89867 50.1098 6.144C50.0564 6.384 50.0351 6.71467 50.0458 7.136H50.9018V7.68H50.0618V9.32C50.0618 9.51733 50.0618 9.71467 50.0618 9.912C50.0618 10.104 50.0644 10.2987 50.0698 10.496L50.6858 10.624V11H48.3338ZM53.1703 11.12C52.7543 11.12 52.3943 11.0347 52.0903 10.864C51.7863 10.688 51.5516 10.4453 51.3863 10.136C51.2209 9.82133 51.1383 9.45867 51.1383 9.048C51.1383 8.63733 51.2263 8.28 51.4023 7.976C51.5836 7.672 51.8289 7.43467 52.1383 7.264C52.4476 7.09333 52.7916 7.008 53.1703 7.008C53.5489 7.008 53.8903 7.09067 54.1943 7.256C54.5036 7.42133 54.7489 7.65867 54.9303 7.968C55.1116 8.272 55.2023 8.632 55.2023 9.048C55.2023 9.464 55.1196 9.82667 54.9543 10.136C54.7889 10.4453 54.5543 10.688 54.2503 10.864C53.9463 11.0347 53.5863 11.12 53.1703 11.12ZM53.1703 10.704C53.3943 10.704 53.5623 10.5733 53.6743 10.312C53.7863 10.0507 53.8423 9.63733 53.8423 9.072C53.8423 8.50133 53.7863 8.08533 53.6743 7.824C53.5623 7.56267 53.3943 7.432 53.1703 7.432C52.9409 7.432 52.7703 7.56267 52.6583 7.824C52.5463 8.08533 52.4903 8.50133 52.4903 9.072C52.4903 9.63733 52.5463 10.0507 52.6583 10.312C52.7703 10.5733 52.9409 10.704 53.1703 10.704ZM55.6457 11V10.624L56.0857 10.536C56.091 10.3387 56.0937 10.128 56.0937 9.904C56.0937 9.68 56.0937 9.48533 56.0937 9.32V8.848C56.0937 8.69867 56.091 8.576 56.0857 8.48C56.0857 8.384 56.083 8.296 56.0777 8.216C56.0777 8.13067 56.075 8.03467 56.0697 7.928L55.5817 7.856V7.544L57.1577 7.008L57.3017 7.096L57.3737 8.04C57.4857 7.69867 57.643 7.44267 57.8457 7.272C58.0484 7.096 58.2484 7.008 58.4457 7.008C58.6217 7.008 58.7737 7.05867 58.9017 7.16C59.0297 7.256 59.1097 7.40267 59.1417 7.6C59.1364 7.808 59.0804 7.97067 58.9737 8.088C58.867 8.2 58.7337 8.256 58.5737 8.256C58.3497 8.256 58.1444 8.13067 57.9577 7.88L57.9097 7.816C57.7924 7.928 57.683 8.06933 57.5817 8.24C57.4857 8.41067 57.4164 8.58933 57.3737 8.776V9.32C57.3737 9.48533 57.3737 9.67467 57.3737 9.888C57.3737 10.1013 57.3764 10.3013 57.3817 10.488L58.0137 10.624V11H55.6457ZM59.3724 11V10.624L59.8044 10.528C59.8098 10.336 59.8124 10.128 59.8124 9.904C59.8124 9.68 59.8124 9.48533 59.8124 9.32V8.856C59.8124 8.63733 59.8098 8.46933 59.8044 8.352C59.8044 8.22933 59.7991 8.088 59.7884 7.928L59.3004 7.856V7.544L60.8764 7.008L61.0204 7.096L61.0684 7.672C61.2551 7.45333 61.4498 7.288 61.6524 7.176C61.8604 7.064 62.0818 7.008 62.3164 7.008C62.8658 7.008 63.2204 7.24533 63.3804 7.72C63.5991 7.45333 63.8098 7.26933 64.0124 7.168C64.2204 7.06133 64.4391 7.008 64.6684 7.008C65.0738 7.008 65.3698 7.12533 65.5564 7.36C65.7431 7.59467 65.8364 7.94933 65.8364 8.424V9.32C65.8364 9.49067 65.8364 9.688 65.8364 9.912C65.8364 10.136 65.8391 10.344 65.8444 10.536L66.2444 10.624V11H64.1804V10.624L64.5724 10.528C64.5778 10.336 64.5804 10.1307 64.5804 9.912C64.5804 9.688 64.5804 9.49067 64.5804 9.32V8.544C64.5804 8.24533 64.5458 8.04533 64.4764 7.944C64.4071 7.83733 64.2898 7.784 64.1244 7.784C63.9004 7.784 63.6764 7.88 63.4524 8.072C63.4578 8.12 63.4604 8.17067 63.4604 8.224C63.4658 8.272 63.4684 8.32533 63.4684 8.384V9.32C63.4684 9.496 63.4684 9.696 63.4684 9.92C63.4684 10.1387 63.4711 10.3467 63.4764 10.544L63.8524 10.624V11H61.7884V10.624L62.2044 10.528C62.2098 10.336 62.2124 10.1307 62.2124 9.912C62.2124 9.688 62.2124 9.49067 62.2124 9.32V8.552C62.2124 8.26933 62.1778 8.072 62.1084 7.96C62.0444 7.84267 61.9244 7.784 61.7484 7.784C61.6364 7.784 61.5244 7.81067 61.4124 7.864C61.3004 7.91733 61.1938 7.98667 61.0924 8.072V9.32C61.0924 9.48533 61.0924 9.68267 61.0924 9.912C61.0924 10.136 61.0951 10.3467 61.1004 10.544L61.4764 10.624V11H59.3724Z" fill="#4879BB"/><rect x="0.5" y="0.5" width="74" height="17" rx="8.5" stroke="#4879BB"/>
                    </svg>
                  `,
                  width: 75, height: 18 ,
                  verticalAlignment : 'middle' ,
                },
                {
                  text: '소재측정분석 프로토콜' ,
                  fontSize: 8 , height: 18 ,
                  verticalAlignment : 'middle' ,
                  marginTop: 5 ,
                  color: '#222' ,
                },
              ] ,
              columnGap: 8 ,
            } ,
              ...headArr,
            // {
            //   text: crntProtocol.name.replace(/\<p\>|\<\/p\>/gi,''),
            //   color: '#333' ,
            //   font: 'NanumSquareB' ,
            //   fontSize: 14 ,
            //   marginTop: 10 ,
            // } ,
            {
              columns: [
                {
                  text: '등록번호' ,
                  color: '#3B69A7' ,
                  font: 'NanumSquareEB' ,
                  fontSize: 8,
                  width: 50,
                  marginRight: 8,
                } ,
                {
                  text: typeNumber ,
                  color: '#222' ,
                  font: 'NanumSquare' ,
                  fontSize: 8,
                  width: '*',
                } ,
              ] ,
              marginTop: 12 ,
            } ,
            {
              columns: [
                {
                  text: '개정일' ,
                  color: '#3B69A7' ,
                  font: 'NanumSquareEB' ,
                  fontSize: 8,
                  width: 50,
                  marginRight: 8,
                } ,
                {
                  text: formatDateString(crntProtocol.revisionDate) ,
                  color: '#222' ,
                  font: 'NanumSquare' ,
                  fontSize: 8,
                  width: 'auto' ,
                  marginRight: 16,
                } ,
                {
                  text: '재정일' ,
                  color: '#3B69A7' ,
                  font: 'NanumSquareEB' ,
                  fontSize: 8,
                  width: 'auto' ,
                  marginRight: 8,
                } ,
                {
                  text: formatDateString(crntProtocol.enactmentDate) ,
                  color: '#222' ,
                  font: 'NanumSquare' ,
                  fontSize: 8,
                  width: 'auto' ,
                  marginRight: 16,
                } ,
                // {
                //   text: '최종 개정확인일' ,
                //   color: '#3B69A7' ,
                //   font: 'NanumSquareEB' ,
                //   fontSize: 8,
                //   width: 'auto' ,
                //   marginRight: 8,
                // } ,
                // {
                //   text: '' ,
                //   color: '#222' ,
                //   font: 'NanumSquare' ,
                //   fontSize: 8,
                //   width: 'auto' ,
                //   marginRight: 16,
                // } ,
              ] ,
              marginTop: 6 ,
            } ,
            {
              canvas: [
                {
                  type: 'line',
                  x1: 0, y1: 0,
                  x2: pageSize.width - 80 ,
                  y2: 0,
                  lineWidth: 1,
                  lineColor: '#DAE4F2'
                }
              ] ,
              marginTop: 16,
              marginBottom: 24,
            } ,
          ],
        }
        // { text: 'simple text', alignment: (currentPage % 2) ? 'left' : 'right' },
        // { canvas: [ { type: 'rect', x: 170, y: 32, w: pageSize.width - 170, h: 40 } ] }
      }

      function footer ( currentPage , pageCount , pageSize ) {
        if (currentPage === 1) {
          return null; // 첫 번째 페이지에서는 헤더를 표시하지 않음
        }

        return [
          {
            margin: [40, 10, 40, 0], // 상단 여백 지정
            canvas: [
              {
                type: 'line',
                x1: 0, y1: 0,
                x2: pageSize.width - 80, y2: 0,
                lineWidth: 1,
                lineColor: '#DAE4F2'
              }
            ] ,
          } ,
          {
            text: [
              {
                color: '#999',
                fontSize: 10,
                text : currentPage.toString() + '/' + pageCount.toString() ,
                alignment : 'center' ,
              } ,
            ] ,
            marginTop: 8,
          } ,

        ]
      } ;

      const pageSize = { width: 595, height: 842 }; // A4 페이지 크기
      const docDefinition = {
        /* content : [
          {
            text: 'Page 1',
            pageBreak: 'after' // 'after'는 "Page 1" 텍스트가 첫 번째 페이지의 끝에서 페이지를 나누도록 지시합니다.
          },
          { text: 'This is the title', style: 'title' },
          { text: '이것은 부제목입니다.', style: 'subtitle' },
          { text: 'This is some sample text in English.', style: 'body' },
          { text: '이것은 샘플 한글 텍스트입니다.', style: 'body' },
          {
            text: 'Page 2'
          } ,
          ...textArr ,
        ] ,  */
        // content: (currentPage, pageCount, pageSize) => content(currentPage, pageCount, pageSize),

        header: (currentPage, pageCount, pageSize) => header(currentPage, pageCount, pageSize),
        // content: createContent() ,
        content: [
          {
            text: typeNumber ,
            absolutePosition: { x: 32 , y: 40 } ,
            color : '#666' ,
            fontSize : 10 ,
          } ,
          {
            stack : [
              {
                svg: `
                  <svg fill="none">
                    <path d="M18.848 13.352V12.488H22.56V13.352L21.04 13.544L18.928 16.072L22.08 22.024L23.056 22.136V23H18.432V22.136L19.2 22.056L17.232 18.072L16.32 19.16C16.32 19.6187 16.32 20.088 16.32 20.568C16.3307 21.048 16.3413 21.528 16.352 22.008L17.392 22.136V23H12.528V22.136L13.728 22.008C13.7493 21.3573 13.76 20.7013 13.76 20.04C13.76 19.3787 13.76 18.712 13.76 18.04V17.448C13.76 16.7867 13.76 16.1253 13.76 15.464C13.76 14.792 13.7493 14.1307 13.728 13.48L12.528 13.352V12.488H17.568V13.352L16.352 13.48C16.3413 14.1307 16.3307 14.7867 16.32 15.448C16.32 16.1093 16.32 16.776 16.32 17.448V17.976L19.904 13.544L18.848 13.352ZM23.2963 19.656V18.216H27.4403V19.656H23.2963ZM28.2099 23V22.136L29.7619 21.944V13.512L28.3539 13.352V12.488H32.5779L35.1859 19.528L37.6339 12.488H41.6819V13.352L40.5459 13.48C40.5352 14.1307 40.5245 14.792 40.5139 15.464C40.5139 16.1253 40.5139 16.7867 40.5139 17.448V18.04C40.5139 18.7013 40.5139 19.3627 40.5139 20.024C40.5245 20.6853 40.5352 21.3467 40.5459 22.008L41.7299 22.136V23H36.6259V22.136L37.7939 21.992C37.8152 21.3413 37.8205 20.7067 37.8099 20.088C37.8099 19.4693 37.8152 18.8987 37.8259 18.376L37.8579 14.84L35.0099 23H33.7779L30.7219 14.824L30.8019 18.024V21.928L32.1139 22.136V23H28.2099ZM48.5931 23.224C47.6651 23.224 47.0785 22.84 46.8331 22.072C46.4918 22.4347 46.1611 22.7227 45.8411 22.936C45.5318 23.1387 45.0998 23.24 44.5451 23.24C43.9265 23.24 43.4198 23.064 43.0251 22.712C42.6411 22.36 42.4491 21.8533 42.4491 21.192C42.4491 20.808 42.5345 20.4613 42.7051 20.152C42.8758 19.8427 43.1851 19.5547 43.6331 19.288C44.0811 19.0213 44.7158 18.7707 45.5371 18.536C45.6971 18.4827 45.8838 18.4293 46.0971 18.376C46.3105 18.3227 46.5291 18.2693 46.7531 18.216V17.688C46.7531 16.9733 46.6625 16.488 46.4811 16.232C46.3105 15.976 45.9691 15.848 45.4571 15.848C45.3825 15.848 45.3131 15.848 45.2491 15.848C45.1851 15.848 45.1105 15.8533 45.0251 15.864L44.9451 16.568C44.9345 17.0907 44.8118 17.4693 44.5771 17.704C44.3531 17.9387 44.0865 18.056 43.7771 18.056C43.1905 18.056 42.8331 17.7893 42.7051 17.256C42.7478 16.5947 43.0838 16.056 43.7131 15.64C44.3425 15.224 45.2331 15.016 46.3851 15.016C47.4091 15.016 48.1398 15.2507 48.5771 15.72C49.0251 16.1893 49.2491 16.9627 49.2491 18.04V21.624C49.2491 21.9333 49.3665 22.088 49.6011 22.088C49.6865 22.088 49.7665 22.0667 49.8411 22.024C49.9158 21.9707 49.9958 21.8747 50.0811 21.736L50.5131 22.024C50.3211 22.4507 50.0705 22.76 49.7611 22.952C49.4625 23.1333 49.0731 23.224 48.5931 23.224ZM44.8171 20.776C44.8171 21.1707 44.9078 21.464 45.0891 21.656C45.2811 21.848 45.5105 21.944 45.7771 21.944C45.8945 21.944 46.0171 21.9173 46.1451 21.864C46.2731 21.8107 46.4758 21.688 46.7531 21.496V18.904C46.6145 18.9467 46.4758 18.9947 46.3371 19.048C46.2091 19.0907 46.0971 19.1333 46.0011 19.176C45.6385 19.3253 45.3505 19.5387 45.1371 19.816C44.9238 20.0827 44.8171 20.4027 44.8171 20.776ZM50.6046 26.632V25.88L51.5006 25.688C51.5113 25.1867 51.5166 24.7173 51.5166 24.28C51.5273 23.8533 51.5326 23.4427 51.5326 23.048V18.712C51.5326 18.2747 51.5273 17.9387 51.5166 17.704C51.5166 17.4587 51.506 17.176 51.4846 16.856L50.4926 16.712V16.088L53.6286 15.016L53.9006 15.176L53.9646 16.072C54.6366 15.368 55.426 15.016 56.3326 15.016C56.9193 15.016 57.4473 15.1707 57.9166 15.48C58.386 15.7893 58.7593 16.248 59.0366 16.856C59.3246 17.464 59.4686 18.2107 59.4686 19.096C59.4686 19.9493 59.3086 20.6907 58.9886 21.32C58.6686 21.9387 58.2473 22.4133 57.7246 22.744C57.2126 23.0747 56.6526 23.24 56.0446 23.24C55.2233 23.24 54.5513 22.9627 54.0286 22.408V23.032C54.0286 23.4267 54.0286 23.8373 54.0286 24.264C54.0393 24.6907 54.05 25.1493 54.0606 25.64L55.0846 25.88V26.632H50.6046ZM55.1646 16.408C54.962 16.408 54.77 16.4507 54.5886 16.536C54.418 16.6213 54.2473 16.728 54.0766 16.856V21.496C54.3966 21.7627 54.7433 21.896 55.1166 21.896C55.5966 21.896 55.986 21.672 56.2846 21.224C56.594 20.776 56.7486 20.0773 56.7486 19.128C56.7486 18.1787 56.5993 17.4907 56.3006 17.064C56.0126 16.6267 55.634 16.408 55.1646 16.408ZM68.1918 13.416H67.8238C67.8131 14.0773 67.8024 14.744 67.7918 15.416C67.7918 16.088 67.7918 16.7653 67.7918 17.448V18.088H68.2558C68.9598 18.088 69.4878 17.864 69.8398 17.416C70.1918 16.9573 70.3678 16.3653 70.3678 15.64C70.3678 14.904 70.1758 14.3493 69.7918 13.976C69.4184 13.6027 68.8851 13.416 68.1918 13.416ZM63.8717 13.352V12.488H68.2238C69.3331 12.488 70.2291 12.6213 70.9118 12.888C71.5944 13.144 72.0904 13.512 72.3998 13.992C72.7198 14.4613 72.8798 15.016 72.8798 15.656C72.8798 16.264 72.7304 16.824 72.4318 17.336C72.1438 17.8373 71.6638 18.2373 70.9918 18.536C70.3198 18.8347 69.4024 18.984 68.2398 18.984H67.7918C67.7918 19.4427 67.7918 19.928 67.7918 20.44C67.8024 20.9413 67.8131 21.4587 67.8238 21.992L69.2478 22.136V23H63.8717V22.136L65.0718 22.008C65.0931 21.3573 65.1038 20.7013 65.1038 20.04C65.1038 19.3787 65.1038 18.712 65.1038 18.04V17.448C65.1038 16.7867 65.1038 16.1253 65.1038 15.464C65.1038 14.792 65.0931 14.1307 65.0718 13.48L63.8717 13.352ZM73.3535 23V22.248L74.2335 22.056C74.2442 21.6507 74.2495 21.2453 74.2495 20.84C74.2602 20.4347 74.2655 20.0347 74.2655 19.64V12.936L73.2735 12.776V12.104L76.6335 11.384L76.8895 11.544L76.8255 13.784V19.64C76.8255 20.0453 76.8255 20.4507 76.8255 20.856C76.8362 21.2613 76.8468 21.6667 76.8575 22.072L77.7375 22.248V23H73.3535ZM84.5931 23.224C83.6651 23.224 83.0785 22.84 82.8331 22.072C82.4918 22.4347 82.1611 22.7227 81.8411 22.936C81.5318 23.1387 81.0998 23.24 80.5451 23.24C79.9265 23.24 79.4198 23.064 79.0251 22.712C78.6411 22.36 78.4491 21.8533 78.4491 21.192C78.4491 20.808 78.5345 20.4613 78.7051 20.152C78.8758 19.8427 79.1851 19.5547 79.6331 19.288C80.0811 19.0213 80.7158 18.7707 81.5371 18.536C81.6971 18.4827 81.8838 18.4293 82.0971 18.376C82.3105 18.3227 82.5291 18.2693 82.7531 18.216V17.688C82.7531 16.9733 82.6625 16.488 82.4811 16.232C82.3105 15.976 81.9691 15.848 81.4571 15.848C81.3825 15.848 81.3131 15.848 81.2491 15.848C81.1851 15.848 81.1105 15.8533 81.0251 15.864L80.9451 16.568C80.9345 17.0907 80.8118 17.4693 80.5771 17.704C80.3531 17.9387 80.0865 18.056 79.7771 18.056C79.1905 18.056 78.8331 17.7893 78.7051 17.256C78.7478 16.5947 79.0838 16.056 79.7131 15.64C80.3425 15.224 81.2331 15.016 82.3851 15.016C83.4091 15.016 84.1398 15.2507 84.5771 15.72C85.0251 16.1893 85.2491 16.9627 85.2491 18.04V21.624C85.2491 21.9333 85.3665 22.088 85.6011 22.088C85.6865 22.088 85.7665 22.0667 85.8411 22.024C85.9158 21.9707 85.9958 21.8747 86.0811 21.736L86.5131 22.024C86.3211 22.4507 86.0705 22.76 85.7611 22.952C85.4625 23.1333 85.0731 23.224 84.5931 23.224ZM80.8171 20.776C80.8171 21.1707 80.9078 21.464 81.0891 21.656C81.2811 21.848 81.5105 21.944 81.7771 21.944C81.8945 21.944 82.0171 21.9173 82.1451 21.864C82.2731 21.8107 82.4758 21.688 82.7531 21.496V18.904C82.6145 18.9467 82.4758 18.9947 82.3371 19.048C82.2091 19.0907 82.0971 19.1333 82.0011 19.176C81.6385 19.3253 81.3505 19.5387 81.1371 19.816C80.9238 20.0827 80.8171 20.4027 80.8171 20.776ZM89.9411 23.24C89.2265 23.24 88.6665 23.0693 88.2611 22.728C87.8558 22.376 87.6531 21.8053 87.6531 21.016C87.6531 20.7387 87.6531 20.4827 87.6531 20.248C87.6638 20.0027 87.6691 19.7253 87.6691 19.416V16.36H86.6291V15.416L87.8131 15.256L88.6131 13.016H90.2451L90.2131 15.272H91.8931V16.36H90.2131V20.84C90.2131 21.2133 90.2878 21.4907 90.4371 21.672C90.5971 21.8427 90.7945 21.928 91.0291 21.928C91.3065 21.928 91.5945 21.8107 91.8931 21.576L92.2931 21.96C92.0798 22.3653 91.7811 22.68 91.3971 22.904C91.0238 23.128 90.5385 23.24 89.9411 23.24ZM92.6675 23V22.248L93.5475 22.072C93.5582 21.6667 93.5635 21.2613 93.5635 20.856C93.5742 20.4507 93.5795 20.0453 93.5795 19.64V16.36H92.5395V15.416L93.6115 15.288C93.6968 14.5627 93.8355 13.9813 94.0275 13.544C94.2302 13.096 94.5022 12.696 94.8435 12.344C95.2382 11.9493 95.6808 11.6667 96.1715 11.496C96.6728 11.3147 97.1528 11.224 97.6115 11.224C98.0595 11.224 98.4648 11.3093 98.8275 11.48C99.1902 11.64 99.4248 11.9333 99.5315 12.36C99.5208 12.6587 99.4142 12.9147 99.2115 13.128C99.0195 13.3307 98.7422 13.432 98.3795 13.432C98.1128 13.432 97.8622 13.3413 97.6275 13.16C97.3928 12.9787 97.1635 12.6907 96.9395 12.296L96.8115 12.104C96.5235 12.4027 96.3262 12.7973 96.2195 13.288C96.1128 13.768 96.0702 14.4293 96.0915 15.272H97.8035V16.36H96.1235V19.64C96.1235 20.0347 96.1235 20.4293 96.1235 20.824C96.1235 21.208 96.1288 21.5973 96.1395 21.992L97.3715 22.248V23H92.6675ZM102.341 23.24C101.509 23.24 100.789 23.0693 100.181 22.728C99.5725 22.376 99.1032 21.8907 98.7725 21.272C98.4418 20.6427 98.2765 19.9173 98.2765 19.096C98.2765 18.2747 98.4525 17.56 98.8045 16.952C99.1672 16.344 99.6578 15.8693 100.277 15.528C100.895 15.1867 101.583 15.016 102.341 15.016C103.098 15.016 103.781 15.1813 104.389 15.512C105.007 15.8427 105.498 16.3173 105.861 16.936C106.223 17.544 106.405 18.264 106.405 19.096C106.405 19.928 106.239 20.6533 105.909 21.272C105.578 21.8907 105.109 22.376 104.501 22.728C103.893 23.0693 103.173 23.24 102.341 23.24ZM102.341 22.408C102.789 22.408 103.125 22.1467 103.349 21.624C103.573 21.1013 103.685 20.2747 103.685 19.144C103.685 18.0027 103.573 17.1707 103.349 16.648C103.125 16.1253 102.789 15.864 102.341 15.864C101.882 15.864 101.541 16.1253 101.317 16.648C101.093 17.1707 100.981 18.0027 100.981 19.144C100.981 20.2747 101.093 21.1013 101.317 21.624C101.541 22.1467 101.882 22.408 102.341 22.408ZM107.291 23V22.248L108.171 22.072C108.182 21.6773 108.187 21.256 108.187 20.808C108.187 20.36 108.187 19.9707 108.187 19.64V18.696C108.187 18.3973 108.182 18.152 108.171 17.96C108.171 17.768 108.166 17.592 108.155 17.432C108.155 17.2613 108.15 17.0693 108.139 16.856L107.163 16.712V16.088L110.315 15.016L110.603 15.192L110.747 17.08C110.971 16.3973 111.286 15.8853 111.691 15.544C112.097 15.192 112.497 15.016 112.891 15.016C113.243 15.016 113.547 15.1173 113.803 15.32C114.059 15.512 114.219 15.8053 114.283 16.2C114.273 16.616 114.161 16.9413 113.947 17.176C113.734 17.4 113.467 17.512 113.147 17.512C112.699 17.512 112.289 17.2613 111.915 16.76L111.819 16.632C111.585 16.856 111.366 17.1387 111.163 17.48C110.971 17.8213 110.833 18.1787 110.747 18.552V19.64C110.747 19.9707 110.747 20.3493 110.747 20.776C110.747 21.2027 110.753 21.6027 110.763 21.976L112.027 22.248V23H107.291ZM114.745 23V22.248L115.609 22.056C115.62 21.672 115.625 21.256 115.625 20.808C115.625 20.36 115.625 19.9707 115.625 19.64V18.712C115.625 18.2747 115.62 17.9387 115.609 17.704C115.609 17.4587 115.598 17.176 115.577 16.856L114.601 16.712V16.088L117.753 15.016L118.041 15.192L118.137 16.344C118.51 15.9067 118.9 15.576 119.305 15.352C119.721 15.128 120.164 15.016 120.633 15.016C121.732 15.016 122.441 15.4907 122.761 16.44C123.198 15.9067 123.62 15.5387 124.025 15.336C124.441 15.1227 124.878 15.016 125.337 15.016C126.148 15.016 126.74 15.2507 127.113 15.72C127.486 16.1893 127.673 16.8987 127.673 17.848V19.64C127.673 19.9813 127.673 20.376 127.673 20.824C127.673 21.272 127.678 21.688 127.689 22.072L128.489 22.248V23H124.361V22.248L125.145 22.056C125.156 21.672 125.161 21.2613 125.161 20.824C125.161 20.376 125.161 19.9813 125.161 19.64V18.088C125.161 17.4907 125.092 17.0907 124.953 16.888C124.814 16.6747 124.58 16.568 124.249 16.568C123.801 16.568 123.353 16.76 122.905 17.144C122.916 17.24 122.921 17.3413 122.921 17.448C122.932 17.544 122.937 17.6507 122.937 17.768V19.64C122.937 19.992 122.937 20.392 122.937 20.84C122.937 21.2773 122.942 21.6933 122.953 22.088L123.705 22.248V23H119.577V22.248L120.409 22.056C120.42 21.672 120.425 21.2613 120.425 20.824C120.425 20.376 120.425 19.9813 120.425 19.64V18.104C120.425 17.5387 120.356 17.144 120.217 16.92C120.089 16.6853 119.849 16.568 119.497 16.568C119.273 16.568 119.049 16.6213 118.825 16.728C118.601 16.8347 118.388 16.9733 118.185 17.144V19.64C118.185 19.9707 118.185 20.3653 118.185 20.824C118.185 21.272 118.19 21.6933 118.201 22.088L118.953 22.248V23H114.745Z" fill="#4879BB"/>
                    <rect x="0.5" y="0.5" width="140" height="35" rx="17.5" stroke="#4879BB"/>
                  </svg>
                `,
                width: 141, height: 36 ,
                verticalAlignment : 'middle' ,
              }],
            //   {
            //     text: crntProtocol.name.replace(/\<p\>|\<\/p\>/gi,''),
            //     font: 'NanumSquareEB' ,
            //     color: '#333' ,
            //     fontSize: 20 ,
            //     marginTop: 16 ,
            //   },
            //   {
            //     text: crntProtocol.nameEng.replace(/\<p\>|\<\/p\>/gi,''),
            //     font: 'NanumSquare' ,
            //     color: '#999' ,
            //     fontSize: 14 ,
            //     marginTop: 16 ,
            //   },
            // ] ,
            absolutePosition: { x: 66 , y: 220 } ,
            alignment: 'left', // stack 내의 모든 컨텐츠를 가운데 정렬
          } , ...titleArr,
          {
            svg: `
              <svg fill="none">
                <path d="M49.0909 294C35.4545 294 23.8636 289.236 14.3182 279.708C4.77273 270.181 0 258.611 0 245C0 231.389 4.77273 219.819 14.3182 210.292C23.8636 200.764 35.4545 196 49.0909 196C51.5455 196 53.9345 196.201 56.2582 196.604C58.5709 197.018 60.8182 197.497 63 198.042L129.273 106.983C124.636 101.267 121.025 94.8694 118.44 87.7917C115.844 80.7139 114.545 73.2278 114.545 65.3333C114.545 47.3667 120.955 31.9861 133.773 19.1917C146.591 6.39722 162 0 180 0C198 0 213.409 6.39722 226.227 19.1917C239.045 31.9861 245.455 47.3667 245.455 65.3333C245.455 73.2278 244.091 80.7139 241.364 87.7917C238.636 94.8694 234.955 101.267 230.318 106.983L297 198.042C299.182 197.497 301.429 197.018 303.742 196.604C306.065 196.201 308.455 196 310.909 196C324.545 196 336.136 200.764 345.682 210.292C355.227 219.819 360 231.389 360 245C360 258.611 355.227 270.181 345.682 279.708C336.136 289.236 324.545 294 310.909 294C297.273 294 285.682 289.236 276.136 279.708C266.591 270.181 261.818 258.611 261.818 245C261.818 239.828 262.571 234.857 264.076 230.088C265.571 225.329 267.682 221.044 270.409 217.233L204.136 126.175C202.773 126.719 201.48 127.128 200.258 127.4C199.025 127.672 197.727 128.081 196.364 128.625V198.858C205.909 202.125 213.753 207.978 219.895 216.417C226.025 224.856 229.091 234.383 229.091 245C229.091 258.611 224.318 270.181 214.773 279.708C205.227 289.236 193.636 294 180 294C166.364 294 154.773 289.236 145.227 279.708C135.682 270.181 130.909 258.611 130.909 245C130.909 234.383 133.975 224.921 140.105 216.613C146.247 208.315 154.091 202.397 163.636 198.858V128.625C162.273 128.081 160.975 127.672 159.742 127.4C158.52 127.128 157.227 126.719 155.864 126.175L89.5909 217.233C92.3182 221.044 94.4345 225.329 95.94 230.088C97.4345 234.857 98.1818 239.828 98.1818 245C98.1818 258.611 93.4091 270.181 83.8636 279.708C74.3182 289.236 62.7273 294 49.0909 294ZM49.0909 261.333C53.7273 261.333 57.6164 259.765 60.7582 256.629C63.8891 253.504 65.4545 249.628 65.4545 245C65.4545 240.372 63.8891 236.496 60.7582 233.371C57.6164 230.235 53.7273 228.667 49.0909 228.667C44.4545 228.667 40.5709 230.235 37.44 233.371C34.2982 236.496 32.7273 240.372 32.7273 245C32.7273 249.628 34.2982 253.504 37.44 256.629C40.5709 259.765 44.4545 261.333 49.0909 261.333ZM180 261.333C184.636 261.333 188.525 259.765 191.667 256.629C194.798 253.504 196.364 249.628 196.364 245C196.364 240.372 194.798 236.496 191.667 233.371C188.525 230.235 184.636 228.667 180 228.667C175.364 228.667 171.48 230.235 168.349 233.371C165.207 236.496 163.636 240.372 163.636 245C163.636 249.628 165.207 253.504 168.349 256.629C171.48 259.765 175.364 261.333 180 261.333ZM310.909 261.333C315.545 261.333 319.429 259.765 322.56 256.629C325.702 253.504 327.273 249.628 327.273 245C327.273 240.372 325.702 236.496 322.56 233.371C319.429 230.235 315.545 228.667 310.909 228.667C306.273 228.667 302.389 230.235 299.258 233.371C296.116 236.496 294.545 240.372 294.545 245C294.545 249.628 296.116 253.504 299.258 256.629C302.389 259.765 306.273 261.333 310.909 261.333ZM180 98C189 98 196.707 94.7987 203.122 88.396C209.525 82.0042 212.727 74.3167 212.727 65.3333C212.727 56.35 209.525 48.6624 203.122 42.2707C196.707 35.868 189 32.6667 180 32.6667C171 32.6667 163.298 35.868 156.895 42.2707C150.48 48.6624 147.273 56.35 147.273 65.3333C147.273 74.3167 150.48 82.0042 156.895 88.396C163.298 94.7987 171 98 180 98Z" fill="#E9F2FF"/>
              </svg>
            `,
            width: 322, height: 294 ,
            verticalAlignment : 'middle' ,
            absolutePosition: { x: pageSize.width - 322 , y: pageSize.height - 294 - 159 } ,
            // absolutePosition: { x: pageSize.width - elementWidth, y: 0 },
          } ,
          {
            text: '소재 측정분석프로토콜 사업단',
            font: 'NanumSquare' ,
            color: '#333' ,
            fontSize: 16 ,
            alignment: 'center' ,
            absolutePosition: { x: 0 , y: pageSize.height - 64 } ,
            pageBreak: 'after' // 'after'는 "Page 1" 텍스트가 첫 번째 페이지의 끝에서 페이지를 나누도록 지시합니다.
          },
          ...textArr ,
        ] ,
        footer: (currentPage, pageCount, pageSize) => footer(currentPage, pageCount, pageSize),
        pageMargins : [ 40, 124, 40, 40 ] ,
        // pageMargins: (currentPage, pageCount, pageSize) => pageMargins(currentPage, pageCount, pageSize), // 페이지 여백 설정
        defaultStyle: {
          font: 'NanumSquare' ,
        } ,
        styles: {
          h1: {
            fontSize: 13,
            margin:[0, 12, 0, 5],
            bold: true,
            color: '#333',
          } ,
          table: {
            margin: [5, 5, 5, 5]
          },
          th: {
            margin:[12, 6],
            alignment: 'center',
          },
          subTitle: {
            color: '#666666',
            fontSize: 10,
            bold: true
          },
          title: {
            fontSize: 24,
            bold: true,
          },
          text: {
            color: '#666666',
            fontSize: 10,
          }


        } ,
      } ;

      if(openType == 'open'){
        pdfMake.createPdf(docDefinition).open();
      }else {
        pdfMake.createPdf(docDefinition).download();
      }

      // pdfMake.createPdf(docDefinition).download();
      this.loading = false ;
      return;
    },
    async printReady ({ processId , protocolId , keyOfProtocol }, type, images, titleImages, headImages) {
      /**
       * 데이터 많은 페이지
       * 테스트 id : user2
       * 테스트 url  : http://localhost:8080/protocol/editor?processId=5683&editorType=protocol&protocolId=-1
      */
      this.images = images;
      this.headImages = headImages;
      this.titleImages = titleImages;
      processId = processId || this.$route.query.processId ;
      protocolId = protocolId || this.$route.query.protocolId ; 
      keyOfProtocol = keyOfProtocol || this.$route.query.key ; 
      
      await this.setProtocolInfo({ processId , protocolId , keyOfProtocol }) ; 
      await this.setWriter() ; 
      await this.printHandler(type) ;
      return false
    } , 
  }
}
</script>

<style lang="scss" scoped>
.tmpWrap {
  position: fixed; 
  left: 50%; top: 50%; 
  z-index: 9999; 
  display: flex; 
  flex-direction: column; 
  gap: 20px; 
  // visibility: hidden; 

  button {
    background-color: #fff; 
    border: 1px solid #000; 
    padding: 10px; 
    visibility: hidden; 
  }
}
</style>